import { render, staticRenderFns } from "./YearDropdown.vue?vue&type=template&id=bb15f96c&scoped=true"
import script from "./YearDropdown.vue?vue&type=script&lang=js"
export * from "./YearDropdown.vue?vue&type=script&lang=js"
import style0 from "./YearDropdown.vue?vue&type=style&index=0&id=bb15f96c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb15f96c",
  null
  
)

export default component.exports